import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { roleCanAccess } from "./components/Sidebar";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Envios from "./pages/Envios";
import Retiros from "./pages/Retiros";
import Rendiciones from "./pages/Rendiciones";
import Finanzas from "./pages/Finanzas";
import Clientes from "./pages/Clientes";
import Sucursales from "./pages/Sucursales";
import Usuarios from "./pages/Usuarios";
import Tracking from "./pages/Tracking";
import MiRuta from "./pages/MiRuta";
import Solicitudes from "./pages/Solicitudes";
import GestionarSucursal from "./pages/GestionarSucursal";
import Repartidores from "./pages/Repartidores";
import Vehiculos from "./pages/Vehiculos";
import Cod from "./pages/Cod";
import Liquidaciones from "./pages/Liquidaciones";
import MiLiquidacion from "./pages/MiLiquidacion";
import Credito from "./pages/Credito";
import Comisiones from "./pages/Comisiones";
import Almacenamiento from "./pages/Almacenamiento";
import Incidencias from "./pages/Incidencias";
import Documentos from "./pages/Documentos";
import Terminos from "./pages/Terminos";
import Reportes from "./pages/Reportes";
import Configuracion from "./pages/Configuracion";
import MiPerfil from "./pages/MiPerfil";
import Integraciones from "./pages/Integraciones";
import Aprobaciones from "./pages/Aprobaciones";
import TrackPublic from "./pages/TrackPublic";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready || user === null) return <div className="min-h-screen flex items-center justify-center text-[#64748B]">Cargando...</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-[#64748B]">Cargando...</div>;
  if (user) return <Navigate to="/app" replace />;
  return children;
}

function RoleRoute({ path, children }) {
  const { user } = useAuth();
  if (user && !roleCanAccess(user.role, path)) return <Navigate to="/app" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
          <Route path="/track" element={<TrackPublic />} />
          <Route path="/track/:code" element={<TrackPublic />} />
          <Route path="/app" element={<Protected><Layout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="mi-ruta" element={<MiRuta />} />
            <Route path="envios" element={<RoleRoute path="/app/envios"><Envios /></RoleRoute>} />
            <Route path="boleta-ocasional" element={<RoleRoute path="/app/boleta-ocasional"><Envios autoOpen initialTipo="ocasional" /></RoleRoute>} />
            <Route path="retiros" element={<Retiros />} />
            <Route path="rendiciones" element={<Rendiciones />} />
            <Route path="finanzas" element={<RoleRoute path="/app/finanzas"><Finanzas /></RoleRoute>} />
            <Route path="clientes" element={<RoleRoute path="/app/clientes"><Clientes /></RoleRoute>} />
            <Route path="sucursales" element={<RoleRoute path="/app/sucursales"><Sucursales /></RoleRoute>} />
            <Route path="usuarios" element={<RoleRoute path="/app/usuarios"><Usuarios /></RoleRoute>} />
            <Route path="aprobaciones" element={<RoleRoute path="/app/aprobaciones"><Aprobaciones /></RoleRoute>} />
            <Route path="tracking" element={<Tracking />} />
            <Route path="solicitudes" element={<RoleRoute path="/app/solicitudes"><Solicitudes /></RoleRoute>} />
            <Route path="gestionar-sucursal" element={<RoleRoute path="/app/gestionar-sucursal"><GestionarSucursal /></RoleRoute>} />
            <Route path="repartidores" element={<RoleRoute path="/app/repartidores"><Repartidores /></RoleRoute>} />
            <Route path="vehiculos" element={<RoleRoute path="/app/vehiculos"><Vehiculos /></RoleRoute>} />
            <Route path="cod" element={<RoleRoute path="/app/cod"><Cod /></RoleRoute>} />
            <Route path="liquidaciones" element={<RoleRoute path="/app/liquidaciones"><Liquidaciones /></RoleRoute>} />
            <Route path="mi-liquidacion" element={<RoleRoute path="/app/mi-liquidacion"><MiLiquidacion /></RoleRoute>} />
            <Route path="credito" element={<RoleRoute path="/app/credito"><Credito /></RoleRoute>} />
            <Route path="comisiones" element={<RoleRoute path="/app/comisiones"><Comisiones /></RoleRoute>} />
            <Route path="almacenamiento" element={<RoleRoute path="/app/almacenamiento"><Almacenamiento /></RoleRoute>} />
            <Route path="incidencias" element={<RoleRoute path="/app/incidencias"><Incidencias /></RoleRoute>} />
            <Route path="documentos" element={<RoleRoute path="/app/documentos"><Documentos /></RoleRoute>} />
            <Route path="terminos" element={<RoleRoute path="/app/terminos"><Terminos /></RoleRoute>} />
            <Route path="reportes" element={<RoleRoute path="/app/reportes"><Reportes /></RoleRoute>} />
            <Route path="configuracion" element={<RoleRoute path="/app/configuracion"><Configuracion /></RoleRoute>} />
            <Route path="perfil" element={<MiPerfil />} />
            <Route path="integraciones" element={<RoleRoute path="/app/integraciones"><Integraciones /></RoleRoute>} />
          </Route>
          <Route path="/" element={<Navigate to="/app" replace />} />
          <Route path="*" element={<Navigate to="/app" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
